module.exports = __webpack_public_path__ + "icon_liikenne.ee1ef833e4e86de913c5.svg";